import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const MEMBER_WINS_IN_FOOTER_I18N_NAMESPACE =
  '@mc/next/experiments/pen-5824_v1_member_wins_in_footer'

export const i18nInstance = registerI18nResources({
  namespace: MEMBER_WINS_IN_FOOTER_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
